// extracted by mini-css-extract-plugin
export default {"popup":"ConfirmationPopup__popup--2hc","inner":"ConfirmationPopup__inner--2DS","content":"ConfirmationPopup__content--22J","btn":"ConfirmationPopup__btn--Cdk"};